// extracted by mini-css-extract-plugin
export default {"h":"style_h__83tLs","h2":"style_h2__nagav","p2":"style_p2__MCIzT","h3":"style_h3__aY79+"};